export class LicenseResponse {
  licenseId: string;
  dealerName: string | null;
  hwModule: HwModuleResponse | null;
  swModule: SwModuleResponse | null;
  brandCode: string | null;
  licenseKey: string;
  offline: number;
  appModeCode: string;
  offlineLicenseKeyExpirationTime: Date | null;
  offlineLicenseKey?: string;
  licenseType: LicenseTypeResponse;
  licenseDurationTime: number | null;
  licenseDurationUnits: number | null;
  activationTime: Date;
  expirationTime: Date | null;
  hwSerialNumber: string | null;
  maxWorkstations: number | null;
  renewedLicenseId: string | null;
  factoryMode: number;
  moduleBindingActivations: ModuleBindingActivationsResponse[];
  isRenewal: number;

  get productName() {
    return this.hwModule?.brandName ?? this.hwModule?.name ?? this.swModule?.name;
  }

  constructor(params: any = {}) {
    this.licenseId = params.licenseId;
    this.dealerName = params.dealerName;
    this.hwModule = params.hwModule && new HwModuleResponse(params.hwModule);
    this.swModule = params.swModule && new SwModuleResponse(params.swModule);
    this.brandCode = params.brandCode;
    this.licenseKey = params.licenseKey;
    this.offline = params.offline;
    this.offlineLicenseKeyExpirationTime = params.offlineLicenseKeyExpirationTime;
    this.offlineLicenseKey = params.offlineLicenseKey;
    this.hwSerialNumber = params.hwSerialNumber;
    this.licenseType = params.licenseType && new LicenseTypeResponse(params.licenseType);
    this.appModeCode = params.appModuleCode;
    this.licenseDurationTime = params.licenseDurationTime;
    this.licenseDurationUnits = params.licenseDurationUnits;
    this.activationTime = params.activationTime;
    this.expirationTime = params.expirationTime;
    this.maxWorkstations = params.maxWorkstations;
    this.renewedLicenseId = params.renewedLicenseId;
    this.factoryMode = params.factoryMode;
    this.isRenewal = params.isRenewal;
    this.moduleBindingActivations = params.moduleBindingActivations
      ? params.moduleBindingActivations.map((mba) => new ModuleBindingActivationsResponse(mba))
      : [];
  }
}

class HwModuleResponse {
  code: string;
  name: string;
  brandName: string;
  crossDevice: number;

  constructor(module: any = {}) {
    this.code = module.neowiseCode;
    this.name = module.name;
    this.brandName = module.brandName;
    this.crossDevice = module.hwModuleCrossDevice;
  }
}

class SwModuleResponse {
  code: string;
  name: string;

  constructor(moduleResponseType: any = {}) {
    this.code = moduleResponseType.neowiseCode;
    this.name = moduleResponseType.name;
  }
}

class LicenseTypeResponse {
  licenseTypeId: string;
  code: string;
  name: string;

  constructor(moduleResponseType: LicenseTypeResponse) {
    this.licenseTypeId = moduleResponseType.licenseTypeId;
    this.code = moduleResponseType.code;
    this.name = moduleResponseType.name;
  }
}

class ModuleBindingActivationsResponse {
  hwModule: HwModuleResponse | null;
  swModule: SwModuleResponse | null;

  constructor(m: any = {}) {
    this.hwModule = m.hwModule;
    this.swModule = m.swModule;
  }
}
